
import store from '../Store'
import { getActiveLanguage } from 'react-localize-redux';

import { api } from '../services/redux-beesConfig';
import AuthService from './AuthService';


class PaymentService {
  static postPaymentMethod(values) {
    const userID = AuthService.getUserID();
    return api.postPaymentMethod({
      locale: `${getActiveLanguage(store.getState().locale).code}`, id: userID,
    }, values)
      .then((res) => {
        if (res.body.token) {
          AuthService.setToken(res.body.token);
        }
        return res;
      })
      .catch((error) => {
        if (error.status === 401) {
          AuthService.logOut();
        }
        console.log(error);
      });
  }
  static invoicePayment(invoiceId) {
    const userID = AuthService.getUserID();
    return api.postInvoicePayment({
      locale: `${getActiveLanguage(store.getState().locale).code}`, id: userID,
    }, {"invoiceId":[invoiceId]})
    .then((res) => {
      if (res.body.token) {
        AuthService.setToken(res.body.token);
      }
      return res;
    })
    .catch((error) => {
      if (error.status === 401) {
        AuthService.logOut();
      }
      console.log(error);
    });
  }
}
export default PaymentService;



// WEBPACK FOOTER //
// ./src/services/PaymentService.js